export default __webpack_public_path__ + "static/08_嘉宾头像_张政俊-e39872ffcb1f5b4b633579f05fb279df.png";